import React from 'react';
import PropTypes from 'prop-types';
import { Box, useTheme } from '@mui/material';
import dataEnrichment3d from '../../assets/enrichment/data-enrichment-3d.jpg';

/**
 * Shared Data Enrichment identity mark: square framed 3D asset.
 * Used in Actions menu + Data Enrichment modal header.
 */
export default function DataEnrichmentIdentityIcon({
  size = 27,
  'data-testid': dataTestId,
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  // Equal inset so the 3D asset never touches the frame edge.
  const inset = Math.max(3, Math.round(size * 0.12));

  return (
    <Box
      data-testid={dataTestId}
      aria-hidden
      sx={{
        width: size,
        height: size,
        borderRadius: '7px',
        border: isDark ? '1px solid rgba(255,255,255,0.14)' : '1px solid rgba(88,89,91,0.14)',
        backgroundColor: isDark ? '#1E1E1E' : '#FFFFFF',
        boxShadow: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        lineHeight: 0,
        p: `${inset}px`,
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src={dataEnrichment3d}
        alt=""
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'center',
          display: 'block',
          userSelect: 'none',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}

DataEnrichmentIdentityIcon.propTypes = {
  size: PropTypes.number,
  'data-testid': PropTypes.string,
};
